<template>
  <div
    class="lms-wrapper-two"
  >

  <student-nav :obj.sync="statObj"></student-nav>
  <div class="lms-content">
    <student-header class="filled" @toggle-navbar="toggleNavbar($event)" />
    <div class="lms-content-body container" style="bottom: 0; height: calc(100vh - 80px)">
      <ul class="nav nav-line nav-line-profile mg-b-10">
          <li class="nav-item" v-for="(type, i) in types" :key="'tt' + i">
            <!-- {{$route.name}} -->
            <router-link
              :to="{ name: $route.name, params: { cid: type.id } }"
              :class="
                `nav-link d-flex align-items-center ${
                  $route.params.cid == type.id ? 'active' : ''
                }`
              "
              >{{ type.s1 }}</router-link
            >
          </li>
        </ul>

        <div class="row">
          <div class="col-lg-8 col-xl-9">
            <vue-custom-scrollbar
              :style="`height: ${scrollHeight.content}px; position: relative; `"
            >
              <template v-if="canView">
                <div class="row row-sm mg-b-25">
                  <template v-if="tasks.length > 0">
                    <div
                      v-for="(task, i) in tasks"
                      :key="'tsk_' + i"
                      class="col-md-4"
                    >
                      <div class="card card-event" @click="taskDetail(task.id)">
                        <img
                          style="height: 320px"
                          :src="`${task.secondAttachmentUrl}?w=480`"
                          class="card-img-top"
                          alt
                        />
                        <div class="card-body tx-13">
                          <h5>
                            <span>{{ task.task }}</span>
                          </h5>
                          <!-- <p class="mg-b-0">Mar 22 - Mar 24, World Trade Center Metro</p>
                          <span class="tx-12 tx-color-03">Manila, Philippines</span>-->
                        </div>
                        <div class="card-footer tx-13">
                          <!-- <span class="tx-color-03">6,187 people interested</span> -->
                          <button class="btn btn-xs btn-secondary">
                            дэлгэрэнгүй
                          </button>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="wd-100p">
                      <ul class="list-group list-group-flush tx-13">
                        <li class="list-group-item d-flex pd-sm-x-20">
                          <div
                            class="container d-flex justify-content-center ht-100p"
                          >
                            <div
                              class="mx-wd-300 wd-sm-450 ht-100p d-flex flex-column align-items-center justify-content-center pd-t-100"
                            >
                              <div class="wd-80p wd-sm-300 mg-b-15">
                                <img
                                  src="assets/svg/boxempty.svg"
                                  alt
                                  class="img-fluid"
                                />
                              </div>
                              <h4 class="tx-18 text-muted">
                                Мэдээлэл хоосон байна.
                              </h4>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </template>
                </div>
              </template>
              <template v-else>
                <div class="align-center">
                  <div class="vertical-middle">
                    <div class="alert alert-warning mg-b-0" role="alert">
                      <h6 class="alert-heading">Хандах эрх хүрэхгүй байна!</h6>
                      <hr />
                      <p class="mb-0">
                        Таны нийт оноо
                        <template v-if="point.pointOptions != undefined">{{
                          point.pointOptions.reduce(
                            (sum, st) => sum + parseInt(st.point),
                            0
                          ) +
                            " / " +
                            tmzPointSuccess
                        }}</template>
                      </p>
                    </div>
                  </div>
                </div>
              </template>
            </vue-custom-scrollbar>
          </div>
          <div class="col-sm-7 col-md-5 col-lg-4 col-xl-3 mg-t-40 mg-lg-t-0">
            <vue-custom-scrollbar
              :style="`height: ${scrollHeight.right}px; position: relative;`"
            >
              <h6 class="tx-uppercase tx-semibold mg-b-15">Ангилал</h6>
              <nav class="nav nav-classic tx-13">
                <router-link
                  :to="{ name: $route.name, params: { cid: type.id } }"
                  :class="
                    `nav-link ${$route.params.cid == type.id ? 'active' : ''}`
                  "
                  v-for="(type, i) in types"
                  :key="'st' + i"
                >
                  <span>{{ type.s1 }}</span>
                </router-link>
              </nav>
              <go-points v-if="$store.state.app.activeGroup.id !== 9157" class="mg-t-20" :hidePrint="true" />
            </vue-custom-scrollbar>
          </div>
        </div>

    </div>
  </div>
    <b-modal
      v-model="modal.show"
      
      :title="modal.data.task"
      centered
      body-class="pd-0"
      size="xl"
      scrollable
    >
      <div class="modal-body pd-0">
        <div v-show="!readable">
          <div class="text-center">
            <img :src="`${modal.data.secondAttachmentUrl}?w=600`" />
          </div>
          <div class="pd-l-20 pd-r-20">
            <div v-html="modal.data.taskDesc"></div>
          </div>

          <!-- <div class="pd-l-20">
            <div>
              <p class="tx-rubik tx-normal mg-t-auto">
                <b> Гүйцэтгэсэн хүмүүсийн нэрс: {{ modal.data.st1 }} </b>
              </p>
            </div>
          </div> -->
          <!-- <div class="pd-l-20">
            <div>
              <p class="tx-rubik tx-normal mg-t-auto">
                <b> Он: {{ modal.data.dueStartDate | moment("YYYY") }} </b>
              </p>
            </div>
          </div> -->
        </div>
        <file-preview
          :id="modal.data.defaultAttachmentId"
          v-if="modal.rdy"
           v-show="readable"
          :force="true"
          :minusHeight="200"
          @on-file-loaded="onFileLoaded"
        />
      </div>
      <template #modal-footer>
        <div
          v-if="!readable"
          class="d-flex align-items-center justify-content-left wd-100p"
        >
          <div>
           
            <span class="tx-rubik tx-normal" style="font-size: 16px">
              <b> Үнэ: {{ modal.data.budget }}₮ </b>
            </span>
          </div>
          <attach-rating
              v-if="fileInf.ready"
              :fileInf.sync="fileInf"
              class="mg-l-10"
              @on-rate="onRated"
              :allowHalf="false"
              :disabled="true"
            />
          <div class="mg-l-auto">
             
            <button
              type="button"
              class="btn btn-white mg-r-5"
              data-dismiss="modal"
              @click="
                modal.show = false;
                readable = false;
              "
            >
              Болих
            </button>
            <button
              v-if="modal.data.budget > 0 && modal.data.im == null"
              class="btn btn-primary"
              @click="purchaseBook(modal.data)"
            >
              <feather type="shopping-cart" class="mg-r-5" />Худалдаж авах
            </button>
            <button v-else class="btn btn-primary" @click="readable = true">
              <feather type="book-open" class="mg-r-5" />Унших
            </button>
          </div>
        </div>
        <div v-else>
          <attach-rating
            v-if="fileInf.ready"
            :fileInf.sync="fileInf"
            class="mg-l-10"
            @on-rate="onRated"
            :allowHalf="false"
            :disabled="false"
          />
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import vueCustomScrollbar from "vue-custom-scrollbar";
import { request } from "@/api/all";
import { localSave, localRead } from "@/libs/util";

export default {
  components: {
    vueCustomScrollbar,
    studentHeader: () => ({
      component: import("@/views/modules/lms/student/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    filePreview: () => ({
      component: import("@/components/modules/media/previewPage.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    goPoints: () => ({
      component: import("@/views/modules/lms/components/points"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    attachRating: () => ({
      component: import("@/components/modules/media/rate.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data() {
    return {
      readable: false,
      fileInf: {
        ready: false,
        obj: {},
      },
      scrollHeight: {
        contentToolbarHeight: 49,
        nav: 0,
        content: 0,
        right: 0
      },
      nowDate: null,
      types: [],
      tasks: [],
      allCount: 0,
      typeKey: "typemagazine",
      ot: 281,
      groupLogo: "",
      modal: {
        id: 0,
        rdy: false,
        show: false,
        data: {}
      },
      point: {},
      canView: false,
      tmzPointSuccess: 0
    };
  },
  mounted() {
    this.toggleBodyClass("addClass", "app-lms");
    require("@/assets/css/dynamic.lms.css");

    window.addEventListener("resize", this.getWindowHeight);
    this.getWindowHeight();
    let _companyLogo = this.$store.state.app.groupSettings.filter(
      x => x.key == "companyLogo"
    );
    if (_companyLogo.length > 0 && _companyLogo[0].value != undefined) {
      this.groupLogo = _companyLogo[0].value;
    }
    let _pointSuccess = this.$store.state.app.groupSettings.filter(
      x => x.key == "tmzPointSuccess"
    );
    if (_pointSuccess.length > 0 && _pointSuccess[0].value != undefined) {
      this.tmzPointSuccess = parseInt(_pointSuccess[0].value, 10);
    }

    //GetMyTMZPoint({ selectedUserId: 0 })

    request({
      api: { method: "get", url: "learn/GetMyTMZPoint" },
      store: this.$store
    }).then(res => {
      this.point = res.data;
      //console.log(this.point)
      if (
        this.point.pointOptions.reduce(
          (sum, st) => sum + parseInt(st.point),
          0
        ) >= this.tmzPointSuccess
      ) {
        this.canView = true;
        this.init();
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getWindowHeight);
    //this.toggleBodyClass("removeClass", "app-lms");
  },
  destroyed() {
    window.removeEventListener("resize", this.getWindowHeight);
    //this.toggleBodyClass("removeClass", "app-lms");
  },
  methods: {
    onFileLoaded(e) {
      this.fileInf = {
        obj: e,
        ready: true,
      };
    },
    onRated(e) {
      //console.log(e);
      this.fileInf.obj.myRate = e.rate;
      this.fileInf.obj.rateAvg = e.avg;
    },
    purchaseBook(order) {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "post", url: "Payment/CreateInvoiceByTaskId" },
        store: this.$store,
        data: {
          id: order.id,
          taskDesc: order.task,
        },
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.$router.push(`/lms/paymentDetail/${res.data.invoiceId}`);
        }
      });
    },
    init() {

      //console.log( localRead("magazine"));
      if(localRead("magazine")){
        let id = localRead("magazine");
        if(id != 'null'){
          localSave("magazine", null);
          this.taskDetail(id);
        }
        
      }

      request({
        api: { method: "get", url: "type/getdata" },
        params: {
          key: this.typeKey,
          getParentType: false
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.types = res.data.types;
        }
      });

      request({
        api: { method: "POST", url: "TaskCore/GetCoreList" },
        data: {
          skip: 0,
          size: 200,
          ot: this.ot,
          model: {
            isPublic: true,
            //isTender: false,
            locTypeId:
              this.$route.params.cid > 0 ? this.$route.params.cid : null
          }
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          //console.log('GetCoreList', res);
          this.allCount = res.data.allCount;
          this.nowDate = res.data.nowDate;
          this.tasks = res.data.tasks;
        }
      });
    },
    taskDetail(id) {
      this.toggleBodyClass("addClass", "dynamic-locker");

      this.readable = false;

      request({
        api: { method: "get", url: "task/taskInheritedDetail" },
        params: { id: id },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.modal.id = id;
          this.modal.data = res.data.task;
          this.modal.show = true;
          this.modal.rdy = true;
        }
      });
    },
    // read(id) {
    //   this.readable = false;
    //   this.toggleBodyClass("addClass", "dynamic-locker");

    //   request({
    //     api: { method: "get", url: "task/taskInheritedDetail" },
    //     params: { id: id },
    //     store: this.$store,
    //   }).then((res) => {
    //     this.toggleBodyClass("removeClass", "dynamic-locker");
    //     if (res != false) {
    //       this.modal.id = id;
    //       this.modal.data = res.data.task;
    //       this.modal.show = true;
    //       this.modal.rdy = true;
    //     }
    //   });
    // },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    toggleNavbar(shown) {
      if (this.navbarMode == 0) {
        this.navbarMode = 1;
        this.toggleBodyClass("addClass", "lms-sidebar-show");
      } else if (this.navbarMode == 1) {
        if (shown) {
          this.toggleBodyClass("addClass", "navbar-nav-show");
        } else {
          this.navbarMode = 0;
          this.toggleBodyClass("removeClass", "lms-sidebar-show");
        }
      }
    },
    getWindowHeight() {
      let contentSub = 120;
      let navSub = 120;
      let rightSub = 120;
      if (screen.width <= 1024) {
        contentSub = 85;
        navSub = 85;
        rightSub = 85;
      }

      contentSub += this.scrollHeight.contentToolbarHeight;
      rightSub += this.scrollHeight.contentToolbarHeight;

      this.scrollHeight.content = window.innerHeight - contentSub;
      this.scrollHeight.nav = window.innerHeight - navSub;
      this.scrollHeight.right = window.innerHeight - rightSub;
    }
  },
  watch: {
    "$root.$route"(newRoute, oldRoute) {
      if (newRoute.params.cid != oldRoute.params.cid) {
        this.$nextTick(() => {
          this.init();
        });
      }
    }
  }
};
</script>
